import {
  ChangeDetectionStrategy,
  Component, DoCheck,
  EventEmitter,
  Inject,
  Input, OnChanges, OnInit,
  Output, SimpleChanges, ViewChild
} from "@angular/core";
import {RouteModel} from "../../../../routes/models/route.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import * as _ from "lodash";
import {NgxPermissionsService} from "ngx-permissions";

require('./planning-routes-table.scss');
@Component({
  standalone: false,
  selector: 'app-planning-routes-table',
  templateUrl: './planning-routes-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningRoutesTableComponent implements OnInit, OnChanges, DoCheck {

  @Input() routes: RouteModel[];
  @Input() selectedIds: string[];
  @Input() excludeMode: boolean;
  @Input() isLoading: boolean;
  @Input() columns: any;
  @Input() dynamicColumns: any;
  @Input() sortType: any;
  @Input() routesCount: number;
  @Input() highlightedRoute: RouteModel;
  @Input() showRoutes: RouteModel[];
  @Input() serviceAreasMap: any;

  @Output() onAssignRoute = new EventEmitter<RouteModel>();
  @Output() onAssignRouteAndSelectDriver = new EventEmitter<RouteModel>();
  @Output() onHandleUnpackedDeliveries = new EventEmitter<RouteModel>();
  @Output() onReoptimizeRoute = new EventEmitter<string>();
  @Output() onBlockRoute = new EventEmitter<string>();
  @Output() onUnBlockRoute = new EventEmitter<string>();
  @Output() onResetRoute = new EventEmitter<string>();
  @Output() onUpdateBranches = new EventEmitter<RouteModel>();
  @Output() onUpdateResource = new EventEmitter<RouteModel>();
  @Output() onManageAssistants = new EventEmitter<RouteModel>();
  @Output() onChangeRouteColor = new EventEmitter<RouteModel>();
  @Output() onUpdateLogisticsVehicle = new EventEmitter<{ task: TaskModel, route: RouteModel }>();
  @Output() onDeleteRoute = new EventEmitter<string>();
  @Output() onToggleShowRoute = new EventEmitter<RouteModel>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onSelectRoutesChanged = new EventEmitter<{ selectedIds: string[], excludeMode: boolean }>();
  @Output() onSortTypeChange = new EventEmitter<string>();

  @Output() onPrintIkea = new EventEmitter<RouteModel>();
  @Output() onExport = new EventEmitter<string>();
  @Output() onDownloadBillOfLading = new EventEmitter<string>();
  @Output() onPrintBillOfLading = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public selectedKeys: any;
  public asceDescIconsMap: any;
  public hasFleetManagementPermission: boolean;
  public showKeys: any;
  public enabledDynamicColumns: any;


  constructor(@Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService) {
  }

  ngOnInit() {

    this.showKeys = {};

    this.permissionsService.hasPermission('fleetManagement.vehicles.list').then((hasPermission) => {
      this.hasFleetManagementPermission = hasPermission;
    });

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });

    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };

    this._setEnabledDynamicColumns();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.showRoutes && !changes.showRoutes.isFirstChange()) {
      const showRoutesCurrentValue = changes.showRoutes.currentValue,
        showRoutesPreviousValue = changes.showRoutes.previousValue;

      if (!_.isEqual(showRoutesCurrentValue.length, showRoutesPreviousValue.length)) {
        this.showKeys = {};
        _.forEach(showRoutesCurrentValue, (showRoute) => {
          this.showKeys[showRoute.id] = true;
        })
      }
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }

    if (changes.dynamicColumns && !changes.dynamicColumns.isFirstChange()) {
      this._setEnabledDynamicColumns();
    }
  }

  ngAfterViewInit(): void {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];


    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    })
  }

  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  onToggleSelectAll() {
    this.onSelectRoutesChanged.emit({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleRoute(route) {
    this.selectedKeys[route.rid] = !this.selectedKeys[route.rid];
    this.onSelectRoutesChanged.emit({
      selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
      excludeMode: this.excludeMode
    });
  }

  onSortChange(name: string) {
    this.onSortTypeChange.emit(name);
  }

  private _setEnabledDynamicColumns() {
    this.enabledDynamicColumns = this.dynamicColumns?.filter((c) => c.enabled) || [];
  }

}
